/**
 * The different Firebase auth possibilities
 */
export enum FirebaseAuthMethodEnum {
    GOOGLE = "GOOGLE",
    FACEBOOK = "FACEBOOK",
    PHONE = "PHONE",
    MAIL = "MAIL",
    APPLE="APPLE"
}
